import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { PersonaData } from '../../services/persona/persona.mapping'

/** ペルソナの場面・目的・目安所要時間を表示する standalone コンポーネント */
@Component({
  selector: 'app-persona-briefing',
  standalone: true,
  templateUrl: './persona-briefing.component.html',
  styleUrls: ['./persona-briefing.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PersonaBriefingComponent {
  @Input({ required: true }) persona!: PersonaData

  /** 3 欄すべて未設定なら要素ごと描画しない */
  get hasBriefing(): boolean {
    const p = this.persona
    return !!p.scene || !!p.purpose || p.estimatedMinutes != null
  }
}
